const noop = () => { };
export const noopLogger = {
    log: noop,
    error: noop,
    info: noop,
    trace: noop,
    debug: noop,
};
//# sourceMappingURL=noop-logger.js.map